import { useSelector } from 'react-redux';
import type { AppState } from '~/reducers';
import { getDateOneMonthAgo } from '~/domain/changelog/utils/getDateOneMonthAgo';

export const useGetUnreadChangeLogItems = () => {
  const changeLog = useSelector((state: AppState) => state.changeLog);
  const minDate = getDateOneMonthAgo();
  const unreadItems = changeLog.items.filter(
    (item) => item.date > changeLog.lastReadChangeLogItemDate && item.date > minDate
  );
  return { items: unreadItems };
};
